// src/tenant/tenantApi.js
import { api } from "../lib/api";

export async function fetchTenantsFlexible() {
  // 1) rota pública
  try {
    const r = await api.get("/api/tenants/public");
    if (Array.isArray(r.data)) return r.data;
  } catch {}
  // 2) rota privada (requer bearer/cookie)
  try {
    const r = await api.get("/api/user/tenants");
    // esse endpoint, pelo seu exemplo, retorna { tenants: [...] }
    const arr = Array.isArray(r.data?.tenants) ? r.data.tenants : [];
    return arr;
  } catch (err) {
    // propague o erro final para a UI tratar
    throw err;
  }
}
